import React from "react";

function stringToColor(str:string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    // Keep it 32-bit
    hash = hash & hash;
  }
  let color = ((hash & 0x00ffffff) >>> 0).toString(16).toUpperCase();
  return "#" + ("000000" + color).slice(-6);
}

const NoImageView = ({ text = "", radius = 0, height, width }:any) => {
  const backgroundColor = stringToColor(text);

  const containerStyle = {
    borderRadius: radius,
    overflow: "hidden",
    width: width || "100%",
    height: height || "100%",
  };

  const gradientStyle = {
    borderRadius: radius,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    background: `linear-gradient(to bottom left, ${backgroundColor}, #00120c)`,
  };

  return (
    <div style={containerStyle}>
      <div style={gradientStyle}></div>
    </div>
  );
};

export default NoImageView;
